import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const PDF = createSvgIcon(
  <path d="m16.091 0 5.659 5.659V12H19.5V8.25h-6v-6h-9V12H2.25V0h13.841Zm-.341 2.841V6h3.159L15.75 2.841Zm-12 11.409H0V24h2.25v-2.25h1.5a3.75 3.75 0 1 0 0-7.5Zm-1.5 5.25v-3h1.5a1.5 1.5 0 0 1 0 3h-1.5Zm18-.75V16.5H24v-2.25h-6V24h2.25v-3H24v-2.25h-3.75ZM9 14.25h3.375a4.125 4.125 0 0 1 4.125 4.125v1.5A4.125 4.125 0 0 1 12.375 24H9v-9.75Zm2.25 2.25v5.25h1.125c1.036 0 1.875-.84 1.875-1.875v-1.5c0-1.035-.84-1.875-1.875-1.875H11.25Z" />,
  'PDF'
);

export { PDF };